<template>
  <div class="user-page-wrapper" v-if="ready">
    <div class="user-container">
      <div class="main-info">
        <div class="avatar">
          <vs-avatar size="120" history history-gradient>
            <img :src="user.profile_image.large" alt="profile img" />
          </vs-avatar>
        </div>
        <div class="info">
          <div class="name">
            {{ user.first_name }}
            {{ user.last_name }}
          </div>
          <div class="links">
            <div class="location" v-show="user.location">
              <font-awesome-icon
                class="icon map-marked"
                icon="map-marker-alt"
              />
              {{ user.location }}
            </div>
            <div class="link" v-show="user.portfolio_url">
              <font-awesome-icon class="icon map-marked" icon="globe" />
              <a :href="user.portfolio_url">Portifolio</a>
            </div>
          </div>
          <div class="bio-wrapper">{{ user.bio }}</div>
        </div>
        <div class="btn-wrapper">
          <div class="btn">
            <vs-button>
              Follow
            </vs-button>
          </div>
        </div>
      </div>
      <div class="user-stats-wrapper">
        <div class="user-stats">
          <div>Total Likes</div>
          <span>{{ user.total_likes }}</span>
        </div>
        <div class="user-stats">
          <div>Total Downloads</div>
          <span>{{ user.downloads }}</span>
        </div>
      </div>
    </div>

    <div class="photos-wrapper">
      <stack :column-min-width="220" :gutter-height="30" monitor-images-loaded>
        <stack-item
          v-for="(image, i) in userPhotos"
          :key="i"
          style="transition: transform 300ms"
        >
          <img
            class="image-wrapper"
            :src="image.urls.thumb"
            :alt="image.alt_description"
            @click="handlePhotoPage(image.id)"
          />
        </stack-item>
      </stack>
    </div>
  </div>
</template>

<script>
  import { Stack, StackItem } from "vue-stack-grid";
  import { library } from "@fortawesome/fontawesome-svg-core";

  import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
  import { faGlobe } from "@fortawesome/free-solid-svg-icons";
  library.add(faMapMarkerAlt, faGlobe);
  export default {
    name: "User page",
    components: {
      Stack,
      StackItem,
    },
    data() {
      return {
        user: [],
        userPhotos: [],
        ready: false,
      };
    },
    methods: {
      handlePhotoPage(id) {
        this.$router.push(`/photo/${id}`);
      },
      getUserData() {
        this.$http.get(`/users/${this.$route.params.username}`).then((res) => {
          this.user = res.data;
        });
        this.$http
          .get(`/users/${this.$route.params.username}/photos`)
          .then((res) => {
            this.userPhotos = res.data;
            this.ready = true;
          })
          .catch((err) => {
            console.log(err);
          });
      },
    },
    created() {
      this.getUserData();
    },
  };
</script>

<style lang="scss" scoped>
  .user-page-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;

    .user-container {
      width: 60%;
      height: 40%;
      background: white;
      border-radius: 5px;
      margin: 2rem 0;
      box-shadow: 0 0 30px 0 rgba(82, 63, 105, 0.05);

      .main-info {
        width: 100%;
        height: 70%;
        border-bottom: 1px solid lightgray;
        display: flex;
        flex-direction: row;

        .avatar {
          width: 200px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .info {
          width: 40%;
          overflow: hidden;
          height: 100%;
          display: flex;
          align-self: center;
          justify-content: center;
          flex-direction: column;

          .name {
            font-size: 19px;
            font-weight: bold;
            color: rgb(75, 75, 75);
            width: 100%;
          }

          .links {
            display: flex;
            flex-direction: row;
            width: 100%;
            justify-content: space-between;
            margin-bottom: 10px;

            .link {
              a {
                text-decoration: none;
                color: black;
              }
            }
          }
        }
        .btn-wrapper {
          width: 30%;
          display: flex;
          justify-content: flex-end;
          padding: 2rem 2rem;

          .btn {
          }
        }
      }
      .user-stats-wrapper {
        width: 100%;
        height: 30%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        justify-content: space-around;

        .user-stats {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          span {
            font-weight: 600;
            font-size: 1.2rem;
            color: #fe8c00;
          }
        }
      }
    }
    .photos-wrapper {
      width: 90%;
      display: flex;
      justify-content: center;

      .vsg-container {
        align-self: center !important;
        height: 0 !important;
      }
      .image-wrapper {
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
          0 4px 6px -2px rgba(0, 0, 0, 0.05);
        cursor: pointer;
        transition: all 0.2s linear;

        &:hover {
          transform: scale(1.1);
          z-index: 10;
          filter: brightness(0.7);
        }
      }
    }
    .icon {
      color: lightgray;
    }
  }
</style>
